export function initCartForm() {
	// Format money
	function formatMoney(cents) {
		if (
			window.Shopify &&
			typeof window.Shopify.formatMoney === "function"
		) {
			const moneyFormat =
				(window.theme && window.theme.moneyFormat) ||
				window.Shopify.money_format ||
				"{{amount}}";
			return window.Shopify.formatMoney(cents, moneyFormat);
		}
		const n = (cents / 100).toFixed(2);
		return `${n.replace(".", ",")} €`;
	}

	// Loading
	function addLoading() {
		document.body.classList.add("is-loading");
	}
	function removeLoading() {
		document.body.classList.remove("is-loading");
	}

	// AJAX
	function ajaxChangeQuantity(lineKey, quantity) {
		return fetch("/cart/change.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({ id: lineKey, quantity }),
		}).then((res) => {
			if (!res.ok) throw new Error("Cart update failed");
			return res.json();
		});
	}

	// ⬅️ Modifica: disabilita SOLO l'input quantità, mai i pulsanti
	function setLineEnabled(lineEl, enabled) {
		lineEl.querySelectorAll(".js-qty-input").forEach((el) => {
			el.disabled = !enabled;
		});
	}

	// Limiti dall'input
	function getBounds(input) {
		const has = (v) =>
			v !== undefined &&
			v !== null &&
			v !== "" &&
			!isNaN(parseInt(v, 10));
		const min = has(input.min) ? parseInt(input.min, 10) : 1;
		const step = has(input.step) ? parseInt(input.step, 10) : 1;
		const max =
			input.hasAttribute("max") && has(input.max)
				? parseInt(input.max, 10)
				: Infinity;
		return { min, max, step };
	}

	// Feedback “massimo raggiunto” (per riga)
	let toastTimer;
	function showMaxReached(lineEl) {
		const el = lineEl.querySelector("[data-max-reached]");
		if (!el) return;
		el.classList.remove("hidden");
		el.setAttribute("aria-live", "polite");
		clearTimeout(toastTimer);
		toastTimer = setTimeout(() => {
			el.classList.add("hidden");
		}, 2000);
		el.animate?.([{ opacity: 0.2 }, { opacity: 1 }], { duration: 250 });
	}

	// Aggiorna DOM dopo AJAX
	function updateDomAfterChange(cartJson, changedKey) {
		const totalEl = document.querySelector("[data-cart-total]");
		if (totalEl) totalEl.textContent = formatMoney(cartJson.total_price);

		const countEl = document.querySelector("[data-cart-count]");
		if (countEl) countEl.textContent = cartJson.item_count;

		const lineEl = document.querySelector(
			`[data-line][data-line-key="${changedKey}"]`
		);
		if (!lineEl) return;

		const item = cartJson.items.find((i) => i.key === changedKey);
		if (!item) {
			lineEl.remove();
			return;
		}

		const input = lineEl.querySelector(".js-qty-input");
		if (input) input.value = item.quantity;

		const linePriceEl = lineEl.querySelector("[data-line-price]");
		if (linePriceEl)
			linePriceEl.textContent = formatMoney(item.final_line_price);
	}

	// Debounce
	function debounce(fn, delay = 500) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn(...args), delay);
		};
	}

	function bindQuantityControls() {
		const incs = document.querySelectorAll(".js-increase-qty");
		const decs = document.querySelectorAll(".js-decrease-qty");
		const inputs = document.querySelectorAll(".js-qty-input");

		// INCREASE
		incs.forEach((btn) => {
			if (btn.classList.contains("js-bound")) return;
			btn.classList.add("js-bound");

			btn.addEventListener("click", async function () {
				const key = this.dataset.key;
				const input = document.getElementById(this.dataset.fieldId);
				if (!key || !input) return;

				const lineEl = this.closest("[data-line]") || document;
				const { min, max, step } = getBounds(input);
				const current = parseInt(input.value, 10) || min;
				const next = Math.min(max, current + step);

				// Già al massimo → feedback, niente AJAX
				if (next === current) {
					showMaxReached(lineEl);
					return;
				}

				input.value = next;

				addLoading();
				setLineEnabled(lineEl, false);
				try {
					const cart = await ajaxChangeQuantity(key, next);
					updateDomAfterChange(cart, key);
					document.dispatchEvent(
						new CustomEvent("cart:updated", { detail: { cart } })
					);
				} catch (err) {
					console.error(err);
				} finally {
					setLineEnabled(lineEl, true);
					removeLoading();
				}
			});
		});

		// DECREASE
		decs.forEach((btn) => {
			if (btn.classList.contains("js-bound")) return;
			btn.classList.add("js-bound");

			btn.addEventListener("click", async function () {
				const key = this.dataset.key;
				const input = document.getElementById(this.dataset.fieldId);
				if (!key || !input) return;

				const lineEl = this.closest("[data-line]") || document;
				const { min, step } = getBounds(input);
				const current = parseInt(input.value, 10) || min;
				const next = Math.max(min, current - step);

				if (next === current) {
					return;
				} // già al minimo

				input.value = next;

				addLoading();
				setLineEnabled(lineEl, false);
				try {
					const cart = await ajaxChangeQuantity(key, next);
					updateDomAfterChange(cart, key);
					document.dispatchEvent(
						new CustomEvent("cart:updated", { detail: { cart } })
					);
				} catch (err) {
					console.error(err);
				} finally {
					setLineEnabled(lineEl, true);
					removeLoading();
				}
			});
		});

		// INPUT MANUALE
		inputs.forEach((inp) => {
			if (inp.classList.contains("js-bound")) return;
			inp.classList.add("js-bound");

			const run = debounce(async () => {
				const key = inp.dataset.key;
				if (!key) return;

				const { min, max, step } = getBounds(inp);
				let val = parseInt(inp.value, 10);
				if (!Number.isFinite(val)) val = min;

				// Allinea allo step (per difetto) e clamp
				const offset = (val - min) % step;
				if (offset !== 0) val = val - offset;
				const clamped = Math.max(min, Math.min(max, val));

				const lineEl = inp.closest("[data-line]") || document;

				// Se digitato oltre max → feedback
				if (val !== clamped && clamped === max) {
					showMaxReached(lineEl);
				}

				inp.value = clamped;

				addLoading();
				setLineEnabled(lineEl, false);
				try {
					const cart = await ajaxChangeQuantity(key, clamped);
					updateDomAfterChange(cart, key);
					document.dispatchEvent(
						new CustomEvent("cart:updated", { detail: { cart } })
					);
				} catch (err) {
					console.error(err);
				} finally {
					setLineEnabled(lineEl, true);
					removeLoading();
				}
			}, 500);

			inp.addEventListener("input", run);
			inp.addEventListener("change", run);
		});
	}

	// Init
	bindQuantityControls();

	// Re-bind su cambi DOM
	const observer = new MutationObserver(bindQuantityControls);
	observer.observe(document.body, { childList: true, subtree: true });

	// Disattiva submit "Aggiorna"
	document.querySelectorAll(".js-cart-update").forEach((btn) => {
		btn.addEventListener("click", (e) => {
			e.preventDefault();
		});
	});
}
